export default "__VITE_ASSET__WX2PWlfQ__"